<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box noBoxes">
        <div :class="currentSection.estatus ? 'row blue_gradient_bg shadow noBoxes shadow_inset' : 'row red_gradient_bg shadow noBoxes shadow_inset'">
          <div class="col-12 pt-4 px-4">
            <button class="btn btn-sm btn-primary" @click="$router.push({ name: 'cat-tienda-bodega' })">
              <i class="fas fa-angle-double-left"></i>
              Volver a Bodegas
            </button>
          </div>
          <div class="position-relative noBoxes">
            <i class="fas fa-sitemap bgIcons"></i>
          </div>
          <div class="col-12 pb-4 pt-2 px-4">
            <h5 class="font-weight-bold pt-3" style="color: #888; padding-bottom: 0px; margin-bottom: 0px;">
              Información de Sección:
            </h5>
            <h2 class="font-weight-bold text-white">
              {{ currentSection.descripcion }}
              <div v-if="currentSection.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
              <div v-if="!currentSection.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip"></div>
            </h2>
            
          </div>
        </div>
        <div class="row mt-4 px-4 justify-content-center">
          <div class="col-sm-12 col-md-4 mt-3">
            <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
              <h6 class="font-weight-bold text-dark">
                Tienda
              </h6>
              <h5>
                {{ currentTienda.nombre }}
              </h5>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 mt-3">
            <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
              <h6 class="font-weight-bold text-dark">
                Pertenencia
              </h6>
              <h5>
                {{ currentBodega.bodega }} - {{ currentBodega.descripcion }}
              </h5>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 mt-3">
            <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
              <h6 class="font-weight-bold text-dark">
                Identidad
              </h6>
              <h5>
                {{ currentSection.seccion }}
              </h5>
            </div>
          </div>
        </div>
        <div v-if="currentSection" class="row px-4 pb-3 pt-5">
          <div class="col-12 d-flex flex-wrap justify-content-center">
              <div style="text-align: right">
                <button class="btn btn-md btn-info text-white" @click="editClickSeccion(current)">
                  <i class="fa fa-edit"></i>
                  Editar Sección
                </button>
                <router-link 
                  v-if="currentSection.estatus" 
                  class="btn btn-md btn-success" 
                  :to="{ 
                    name: 'cat-position-nuevo', 
                    params: { valueForm: 'RK', actionForm: 'add', idAntecesor: currentSection.id } 
                  }">
                  <i class="fa fa-plus"></i>
                  Asignar Rack
                </router-link>
              </div>
            </div>
        </div>
        <div class="row px-4 pb-4">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th class="text-center">Rack</th>
                <th scope="col" class="text-center">Descripción</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody v-if="data.results.length > 0"  v-for="current in data.results" v-bind:key="current.id">
              <tr 
                class="table_row" 
                style="transition: all .5s;" 
                v-bind:style="current == detalle
                  ? 'background: #c9d6e5;'
                  : 'background: #ffffff;'
                  " @click="OpenSlideOpt(current)"
              >
                <td scope="row" class="py-3 table_line">{{ current.id }}</td>
                <td scope="row" class="text-center table_line">{{ current.rack }}</td>
                <td scope="row" class="text-center table_line">{{ current.descripcion }}</td>
                <td scope="row" class="text-center table_line">
                  <div v-if="current.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip">
                  </div>
                </td>
              </tr>
              <tr style="transition: all .5s;" v-if="detalle == current">
                <td colspan="4">
                  <div class="row py-4 px-4 justify-content-center text-center">
                    <div class="col-12 text-left">
                      <h5 class="form-header">Detalle de Rack</h5>
                    </div>
                    
                    <div class="col-12 col-md-6 mb-3 mb-md-0 d-flex align-items-start align-items-md-center">
                      <div class="input-group-append">
                        <router-link
                          class="btn btn-md btn-info text-white me-2"
                          :to="{ 
                            name: 'cat-position-nuevo', 
                            params: { valueForm: 'NV', actionForm: 'add', idAntecesor: current.id } 
                          }"
                        >
                          <i class="fa fa-plus"></i>
                          Asignar Nivel
                        </router-link>
                        <button class="btn btn-md btn-secondary text-white" @click="editClickRack(current)">
                          <i class="fa fa-edit"></i>
                          Editar Rack
                        </button>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 text-lg-right">
                      <b>Nivel(es)</b>
                      <h3 class="text-success mb-0 ">
                        {{ currentNiveles.length }}
                      </h3>
                    </div>
                                        
                    <div class="col-12 mt-4 pb-4">
                      <h6 class="form-header">Niveles Asignados</h6>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col" class="text-center">Id</th>
                            <th scope="col" class="text-center">Nivel</th>
                            <th scope="col" class="text-center">Descripción</th>
                            <th scope="col" class="text-center">Estado</th>
                          </tr>
                        </thead>
                        <tbody v-if="currentNiveles.length > 0"  v-for="(currentNIV, index) in currentNiveles" v-bind:key="index">
                          <tr 
                            class="table_row"
                            @click="openRackDetail(currentNIV.id)"
                          >
                            <td scope="row" class="text-center py-3 table_line">{{ currentNIV.id }}</td>
                            <td scope="row" class="text-center table_line">{{ currentNIV.nivel }}</td>
                            <td scope="row" class="text-center table_line">{{ currentNIV.descripcion }}</td>
                            <td scope="row" class="text-center table_line">
                              <div v-if="currentNIV.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                              <div v-if="!currentNIV.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip">
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="currentNiveles.length < 1">
                          <tr>
                            <td colspan="4">
                              <h6 class="py-4 text-muted text-center">Este Rack Aún No Tiene Niveles Asignados</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table> 
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="data.results.length < 1">
              <tr>
                <td colspan="4">
                  <h6 class="py-4 text-muted text-center">Esta Sección Aún No Tiene Racks Asignados</h6>
                </td>
              </tr>
            </tbody>
          </table>
          
        </div>
        <div class="row px-4 d-flex flex-wrap justify-content-center">
            <div class="col-12 d-flex justify-content-center mt-5">
              <div class="input-group-append">
                <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import BodegaSeccionService from "@/services/catalogos/BodegaSeccionService";
import TiendaBodegaService from "@/services/catalogos/TiendaBodegaService";
import TiendaService from "@/services/catalogos/TiendaService";
import SeccionRackService from "@/services/catalogos/SeccionRackService";
import RackNivelService from "@/services/catalogos/RackNivelService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      idSeccion: 0,
      currentSection: {},
      currentBodega: {},
      currentTienda: {},
      currentRacks: {},
      currentNiveles: {},
      current: {},
      detalle: {},
      currentPage: 1,
      data: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    /**
     * Fragmento necesario para poder setear
     * data de la sección actual mostrandose 
     * en la GUI
     */
    if (this.$route.params.idSeccion) {
      this.idSeccion = this.$route.params.idSeccion;
      this.getCurrentSeccion(this.idSeccion)
    }
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.getSeccionRacks(
        this.idSeccion,
        this.currentPage,
        this.currentTienda.codigo
      );
    },

    /**
     * Método que obtiene las sección actual según el ID
     * recibido como parametro de url
     */
     getCurrentSeccion(seccionID) {
      let self = this;
      BodegaSeccionService.getById(seccionID).then((response) => {
        self.currentSection = response.data;
        self.getBodegaSeccion(self.currentSection.bodega);
        self.getCurrentTiendaSeccion(self.currentSection.tienda);
      });
    },

    /**
     * Método que obtiene la data de la bodega a la que esta asignada
     * la sección actual.
     */
    getBodegaSeccion(bodegaID) {
      let self = this;
      TiendaBodegaService.getById(bodegaID).then((response) => {
        self.currentBodega = response.data;
      });
    },

    /**
     * Método que obtiene la data de la tienda a la que pertenece
     * la sección actual
     */
    getCurrentTiendaSeccion(tiendaID) {
      let self = this;
      TiendaService.getById(tiendaID).then((response) => {
        self.currentTienda = response.data;
        self.getSeccionRacks(self.currentSection.id, self.currentPage, self.currentTienda.codigo);
      });
    },

    /**
     * Método que obtiene los Racks Asignados a la Sección actual
     */
     getSeccionRacks(seccionID, page, tienda) {
      let self = this;
      SeccionRackService.fetch({seccion: seccionID, page: page, tienda: tienda}).then((response) => {
        self.data = response.data;
        self.currentRacks = response.data;
      });
    },

    /**
     * Método que obtiene los Niveles asignados al detalle de
     * Rack clickeado en tabla
     */
     getNivelesRacks(seccionID) {
      let self = this;
      RackNivelService.fetch({rack: seccionID, quitar_paginacion: true}).then((response) => {
        self.currentNiveles = response.data;
      });
    },

    /**
     * Método que nos sirve para accionar el botón
     * Editar Sección
     */
     editClickSeccion() {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = self.$router.resolve({
          name: "cat-position-editar",
          params: { 
            valueForm: 'SC', 
            actionForm: 'edit', 
            idCurrent: self.currentSection.id
          } 
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-position-editar",
          params: { 
            valueForm: 'SC', 
            actionForm: 'edit', 
            idCurrent: self.currentSection.id
          }
        });
      }
    },

    /**
     * Método que nos sirve para accionar el botón
     * Editar el RACK
     */
     editClickRack(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = self.$router.resolve({
          name: "cat-position-editar",
          params: { 
            valueForm: 'RK', 
            actionForm: 'edit', 
            idCurrent: current.id
          } 
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-position-editar",
          params: { 
            valueForm: 'RK', 
            actionForm: 'edit', 
            idCurrent: current.id
          }
        });
      }
    },

    /**
     * Método que setea la data del rack en el panel inferior de
     * cada registro de la tabla, al clickear cualquiera
     * de las secciones de la tabla
     */
     OpenSlideOpt(det) {
      let self = this;
      self.getNivelesRacks(det.id)
      if (self.detalle == det) {
        self.detalle = "";
        self.currentNiveles = [];
        return;
      }
      self.detalle = det;
    },
    /**
     * Método que nos redirige a la pagina de la sección clickeada
     */
     openRackDetail(idNivel) {
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-nivel-rack-id",
          params: { idNivel: idNivel },
          props: { bodegaObj: this.detalle }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: "cat-nivel-rack-id",
          params: { idNivel: idNivel },
          props: { bodegaObj: this.detalle }
        });
      }
    },
  }
}
</script>